module.exports = __webpack_public_path__ + "img/linkDossier.e78a567f.svg";